
import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Typography,
  Button,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Grid,
  CircularProgress,
  Pagination,
  Box,
} from "@mui/material";
import {
  Search as SearchIcon,
  Visibility as EyeIcon,
  Add as PlusIcon,
  Remove as MinusIcon,
  Edit as PenIcon,
  Delete as TrashIcon,
  PersonAdd as UserPlusIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import { apiUrl } from "../../comps/apiUrl";

class CadastroMaquina extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      add: false,
      dados: {
        descricao: "",
        stockone: "0",
        stocktwo: "0",
        sale: false,
        custo: "",
        custograde: "",
        loca: false,
        day: "",
        week: "",
        biweek: "",
        month: "",
      },
      currentPage: 1,
      totalPages: 0,
      itemsPerPage: 100,
      loader: true,
      edit: {},
      trash: {},
      contract: {},
      busca: "",
      rBusca: [],
      TrashContract: {},
      ShowItens: {},
      itens_product: [],
    };
  }

  componentDidMount() {
    document.title = "Cadastro de Equipamentos";
    this.fetchData(this.state.currentPage);
  }

  formatToBRL(value) {
    if (value === undefined || value === null || value === "") return "R$ 0,00";
    if (typeof value === "string" && value.trim().startsWith("R$")) {
      return value;
    }
    let numericValue =
      typeof value === "string"
        ? value.replace(/[^\d,.-]/g, "").replace(",", ".")
        : value;

    let number = parseFloat(numericValue);
    if (isNaN(number)) return "R$ 0,00";

    return number.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  formatarMoeda = (valor) => {
    const apenasNumeros = valor.replace(/\D/g, "");
    if (!apenasNumeros) return "";
    return (Number(apenasNumeros) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  fetchData(page) {
    this.setState({ loader: true });
    fetch(
      `${apiUrl}/v2/equipment/get/list?page=${page}&limit=${this.state.itemsPerPage}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        if (response.status === 510) {
          localStorage.clear();
          window.location.href = "/";
          return;
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const totalItems = data.totalItems || 0;
          const totalPages = Math.ceil(totalItems / this.state.itemsPerPage) || 1;
          this.setState({
            items: data.items || [],
            currentPage: page,
            totalPages,
            loader: false,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loader: false });
        toast.error("Erro ao carregar dados do servidor.");
      });
  }

  handleSearch = (e) => {
    e.preventDefault();
    this.setState({ loader: true });
    fetch(`${apiUrl}/v2/equipment/find?query=${this.state.busca}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ items: data || [], loader: false });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loader: false });
        toast.error("Erro ao realizar busca.");
      });
  };

  handleStockChange = (item, loja, operacao) => {
    fetch(`${apiUrl}/movimentar-estoque`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
      body: JSON.stringify({
        id_produto: item.id_produto,
        loja: loja,
        quantidade: 1,
        operacao: operacao,
      }),
    }).then((response) => {
      if (response.ok) {
        this.setState((prevState) => ({
          items: prevState.items.map((i) => {
            if (i.id_produto === item.id_produto) {
              const diff = operacao === "ENTRADA" ? 1 : -1;
              const estoque_matriz = loja === 1 ? i.estoque_matriz + diff : i.estoque_matriz;
              const estoque_filial = loja === 2 ? i.estoque_filial + diff : i.estoque_filial;
              return {
                ...i,
                estoque_matriz,
                estoque_filial,
                estoque_total: estoque_matriz + estoque_filial,
              };
            }
            return i;
          }),
        }));
        toast.success("Estoque atualizado!");
      } else {
        toast.error("Erro ao movimentar estoque.");
      }
    });
  };

  handleChange = (event) => {
    const { id, value } = event.target;
    this.setState((prevState) => ({
      dados: {
        ...prevState.dados,
        [id]: value,
      },
    }));
  };

  handleEditChange = (event) => {
    const { id, value } = event.target;
    this.setState((prevState) => ({
      edit: {
        ...prevState.edit,
        [id]: value,
      },
    }));
  };

  render() {
    if (this.state.loader) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
          <CircularProgress size={60} />
        </Box>
      );
    }

    return (
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Card variant="outlined">
          <CardHeader
            title={<Typography variant="h5">Cadastro de Equipamentos</Typography>}
            action={
              <Button
                component={Link}
                to="novo"
                variant="contained"
                color="primary"
                startIcon={<UserPlusIcon />}

              >
                Cadastrar equipamento
              </Button>
            }
            sx={{ borderBottom: "1px solid #e0e0e0" }}
          />
          <CardContent>
            {/* Barra de Busca */}
            <Box component="form" onSubmit={this.handleSearch} display="flex" justifyContent="center" mb={4}>
              <Box width={{ xs: "100%", md: "50%" }} display="flex" gap={1}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  placeholder="Digite o termo de busca..."
                  value={this.state.busca}
                  onChange={(e) => this.setState({ busca: e.target.value })}
                />
                <Button type="submit" variant="contained" color="primary">
                  <SearchIcon />
                </Button>
              </Box>
            </Box>

            {/* Tabela de Dados */}
            {this.state.items.length > 0 ? (
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                    <TableRow>
                      <TableCell>Nome do produto</TableCell>
                      <TableCell align="center">Itens</TableCell>
                      <TableCell align="center" style={{ minWidth: 130 }}>Estoque Matriz</TableCell>
                      <TableCell align="center" style={{ minWidth: 130 }}>Estoque Filial</TableCell>
                      <TableCell align="center">Estoque Total</TableCell>
                      <TableCell align="center">Diária</TableCell>
                      <TableCell align="center">Semanal</TableCell>
                      <TableCell align="center">Quinzenal</TableCell>
                      <TableCell align="center">Mensal</TableCell>
                      <TableCell align="center">Valor de Venda</TableCell>
                      <TableCell align="center">Contrato</TableCell>
                      <TableCell align="center">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.items.map((item) => (
                      <TableRow key={item.id_produto} hover>
                        <TableCell>{item.descricao}</TableCell>
                        <TableCell align="center">
                          <IconButton
                            component={Link}
                            to={`/equipamentos/vinculo/${item.id_produto}`}
                            color="primary"
                            size="small"
                          >
                            <EyeIcon />
                          </IconButton>
                        </TableCell>
                        {/* Estoque Matriz */}
                        <TableCell align="center">
                          <Box display="flex" alignItems="center" justifyContent="between">
                            <IconButton
                              size="small"
                              onClick={() => this.handleStockChange(item, 1, "SAIDA")}
                              disabled={item.estoque_matriz <= 0}
                            >
                              <MinusIcon fontSize="small" />
                            </IconButton>
                            <Typography sx={{ mx: 1, minWidth: 20 }}>{item.estoque_matriz}</Typography>
                            <IconButton size="small" onClick={() => this.handleStockChange(item, 1, "ENTRADA")}>
                              <PlusIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                        {/* Estoque Filial */}
                        <TableCell align="center">
                          <Box display="flex" alignItems="center" justifyContent="between">
                            <IconButton
                              size="small"
                              onClick={() => this.handleStockChange(item, 2, "SAIDA")}
                              disabled={item.estoque_filial <= 0}
                            >
                              <MinusIcon fontSize="small" />
                            </IconButton>
                            <Typography sx={{ mx: 1, minWidth: 20 }}>{item.estoque_filial}</Typography>
                            <IconButton size="small" onClick={() => this.handleStockChange(item, 2, "ENTRADA")}>
                              <PlusIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                        <TableCell align="center">{item.estoque_total}</TableCell>
                        <TableCell align="center">{this.formatToBRL(item.day)}</TableCell>
                        <TableCell align="center">{this.formatToBRL(item.week)}</TableCell>
                        <TableCell align="center">{this.formatToBRL(item.biweek)}</TableCell>
                        <TableCell align="center">{this.formatToBRL(item.month)}</TableCell>
                        <TableCell align="center">{this.formatToBRL(item.custograde)}</TableCell>
                        <TableCell align="center">
                          {item.contract ? (
                            <Button
                              variant="contained"
                              color="error"
                              size="small"
                              onClick={() => this.setState({ TrashContract: item })}
                            >
                              Remover
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => this.setState({ contract: item })}
                            >
                              Adicionar
                            </Button>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Box display="flex" gap={0.5} justifyContent="center">
                            <Button
                              component={Link}
                              to={`editar/${item.id_produto}`}
                              color="primary"
                              size="small"

                            >
                              <PenIcon fontSize="small" />
                            </Button>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => this.setState({ trash: item })}
                            >
                              <TrashIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography align="center" color="textSecondary" sx={{ py: 4 }}>
                Nenhum resultado encontrado.
              </Typography>
            )}
          </CardContent>
          {this.state.items.length > 0 && (
            <CardActions sx={{ justifyContent: "center", borderTop: "1px solid #e0e0e0", py: 2 }}>
              <Pagination
                count={this.state.totalPages}
                page={this.state.currentPage}
                onChange={(e, page) => this.fetchData(page)}
                color="primary"
                shape="rounded"
              />
            </CardActions>
          )}
        </Card>

        {/* Modal: Cadastrar Equipamento */}
        <Dialog open={this.state.add} onClose={() => this.setState({ add: false })} fullWidth maxWidth="sm">
          <DialogTitle>Cadastrar Equipamento</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Nome do Equipamento"
                  id="descricao"
                  value={this.state.dados.descricao || ""}
                  onChange={this.handleChange}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Estoque Matriz"
                  id="stockone"
                  value={this.state.dados.stockone || ""}
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) this.handleChange(e);
                  }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Estoque Filial"
                  id="stocktwo"
                  value={this.state.dados.stocktwo || ""}
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) this.handleChange(e);
                  }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.dados.sale || false}
                      onChange={(e) =>
                        this.setState((prev) => ({ dados: { ...prev.dados, sale: e.target.checked } }))
                      }
                    />
                  }
                  label="Disponível para Venda"
                />
              </Grid>
              {this.state.dados.sale && (
                <>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Valor de Custo"
                      value={this.state.dados.custo || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          dados: { ...prev.dados, custo: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Valor de Venda"
                      value={this.state.dados.custograde || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          dados: { ...prev.dados, custograde: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.dados.loca || false}
                      onChange={(e) =>
                        this.setState((prev) => ({ dados: { ...prev.dados, loca: e.target.checked } }))
                      }
                    />
                  }
                  label="Disponível para Locação"
                />
              </Grid>
              {this.state.dados.loca && (
                <>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="Diária"
                      value={this.state.dados.day || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          dados: { ...prev.dados, day: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="Semanal"
                      value={this.state.dados.week || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          dados: { ...prev.dados, week: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="Quinzenal"
                      value={this.state.dados.biweek || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          dados: { ...prev.dados, biweek: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="Mensal"
                      value={this.state.dados.month || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          dados: { ...prev.dados, month: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => this.setState({ add: false })} color="inherit">
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => {
                const { dados } = this.state;
                if (!dados.descricao) return toast.warn("Nome do Equipamento obrigatório!");
                if (dados.sale && !dados.custograde) return toast.warn("Valor de Venda obrigatório!");

                fetch(`${apiUrl}/cadastrar-maquina`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(dados),
                })
                  .then((res) => {
                    if (res.status === 200) {
                      res.json().then((data) => {
                        this.setState((prevState) => ({
                          items: [
                            {
                              id_produto: data.id,
                              descricao: dados.descricao,
                              estoque_matriz: parseInt(dados.stockone) || 0,
                              estoque_filial: parseInt(dados.stocktwo) || 0,
                              estoque_total: (parseInt(dados.stockone) || 0) + (parseInt(dados.stocktwo) || 0),
                              day: dados.day,
                              week: dados.week,
                              biweek: dados.biweek,
                              month: dados.month,
                              sale: dados.sale,
                              custograde: dados.custograde,
                              loca: dados.loca,
                            },
                            ...prevState.items,
                          ],
                          add: false,
                          dados: { stockone: "0", stocktwo: "0", sale: false, loca: false },
                        }));
                        toast.success("Equipamento cadastrado com sucesso!");
                      });
                    }
                  })
                  .catch(() => toast.error("Falha ao comunicar com servidor."));
              }}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal: Editar Equipamento */}
        <Dialog open={Object.keys(this.state.edit).length > 0} onClose={() => this.setState({ edit: {} })} fullWidth maxWidth="sm">
          <DialogTitle>Editar Equipamento</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Nome do Equipamento"
                  id="descricao"
                  value={this.state.edit.descricao || ""}
                  onChange={this.handleEditChange}
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.edit.sale || false}
                      onChange={(e) =>
                        this.setState((prev) => ({ edit: { ...prev.edit, sale: e.target.checked } }))
                      }
                    />
                  }
                  label="Disponível para Venda"
                />
              </Grid>
              {this.state.edit.sale && (
                <>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Valor de Custo"
                      value={this.state.edit.custo || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          edit: { ...prev.edit, custo: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Valor de Venda"
                      value={this.state.edit.custograde || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          edit: { ...prev.edit, custograde: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.edit.loca || false}
                      onChange={(e) =>
                        this.setState((prev) => ({ edit: { ...prev.edit, loca: e.target.checked } }))
                      }
                    />
                  }
                  label="Disponível para Locação"
                />
              </Grid>
              {this.state.edit.loca && (
                <>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="Diária"
                      value={this.state.edit.day || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          edit: { ...prev.edit, day: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="Semanal"
                      value={this.state.edit.week || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          edit: { ...prev.edit, week: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="Quinzenal"
                      value={this.state.edit.biweek || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          edit: { ...prev.edit, biweek: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      label="Mensal"
                      value={this.state.edit.month || ""}
                      onChange={(e) =>
                        this.setState((prev) => ({
                          edit: { ...prev.edit, month: this.formatarMoeda(e.target.value) },
                        }))
                      }
                      size="small"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={() => this.setState({ edit: {} })} color="inherit">
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              onClick={() => {
                const dados = this.state.edit;
                fetch(`${apiUrl}/atualizar-maquina`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token"),
                  },
                  body: JSON.stringify(dados),
                }).then((response) => {
                  if (response.status === 200) {
                    this.setState((prevState) => ({
                      items: prevState.items.map((item) =>
                        item.id_produto === dados.id_produto ? { ...item, ...dados } : item
                      ),
                      edit: {},
                    }));
                    toast.success("Equipamento atualizado com sucesso!");
                  }
                });
              }}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal: Vincular Contrato */}
        <Dialog open={Object.keys(this.state.contract).length > 0} onClose={() => this.setState({ contract: {} })} fullWidth maxWidth="sm">
          <DialogTitle>Vincular Contrato</DialogTitle>
          <DialogContent dividers>
            <Box
              component="form"
              onSubmit={(e) => {
                e.preventDefault();
                if (!this.state.busca.trim()) return toast.warn("Digite algo para buscar");
                fetch(`${apiUrl}/buscar-contrato?s=${this.state.busca}`, {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token"),
                  },
                })
                  .then((res) => (res.status === 404 ? null : res.json()))
                  .then((data) => this.setState({ rBusca: data }))
                  .catch(() => toast.error("Erro ao buscar contrato."));
              }}
              display="flex"
              gap={1}
              mb={2}
            >
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar contrato..."
                value={this.state.busca}
                onChange={(e) => this.setState({ busca: e.target.value })}
              />
              <Button type="submit" variant="contained">Buscar</Button>
            </Box>

            {this.state.rBusca && this.state.rBusca.length > 0 ? (
              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Nome</TableCell>
                      <TableCell>Data</TableCell>
                      <TableCell align="center">Ação</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.rBusca.map((item) => (
                      <TableRow key={item.token}>
                        <TableCell>{item.title}</TableCell>
                        <TableCell>{item.created_at}</TableCell>
                        <TableCell align="center">
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => {
                              const id_maquina = this.state.contract.id_produto;
                              fetch(`${apiUrl}/vincular-contrato`, {
                                method: "POST",
                                headers: {
                                  "Content-Type": "application/json",
                                  authorization: localStorage.getItem("token"),
                                },
                                body: JSON.stringify({ id_contrato: item.token, id_maquina }),
                              }).then((response) => {
                                if (response.status === 200) {
                                  this.setState((prevState) => ({
                                    items: prevState.items.map((i) =>
                                      i.id_produto === id_maquina ? { ...i, contract: item.token } : i
                                    ),
                                    contract: {},
                                    rBusca: [],
                                  }));
                                  toast.success("Contrato vinculado!");
                                }
                              });
                            }}
                          >
                            Vincular
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography align="center" color="textSecondary">Nenhum contrato encontrado.</Typography>
            )}
          </DialogContent>
        </Dialog>

        {/* Modal: Exclusão de Equipamento */}
        <Dialog open={Object.keys(this.state.trash).length > 0} onClose={() => this.setState({ trash: {} })}>
          <DialogTitle>Confirmar Exclusão?</DialogTitle>
          <DialogContent>
            <Typography>Se você confirmar a exclusão, não será possível recuperar os dados do equipamento.</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ trash: {} })}>Cancelar</Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                const id = this.state.trash.id_produto;
                fetch(`${apiUrl}/v2/equipment/delete`, {
                  method: "DELETE",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token"),
                  },
                  body: JSON.stringify({ id }),
                }).then((res) => {
                  if (res.ok) {
                    this.setState((prevState) => ({
                      items: prevState.items.filter((item) => item.id_produto !== id),
                      trash: {},
                    }));
                    toast.success("Equipamento excluído com sucesso!");
                  }
                });
              }}
            >
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal: Desvincular Contrato */}
        <Dialog open={Object.keys(this.state.TrashContract).length > 0} onClose={() => this.setState({ TrashContract: {} })}>
          <DialogTitle>Remover Vínculo de Contrato?</DialogTitle>
          <DialogContent>
            <Typography>Tem certeza de que deseja desvincular o contrato deste equipamento?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ TrashContract: {} })}>Cancelar</Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                const id = this.state.TrashContract.id_produto;
                fetch(`${apiUrl}/unlink-contract`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: localStorage.getItem("token"),
                  },
                  body: JSON.stringify({ id }),
                }).then((res) => {
                  if (res.status === 200) {
                    this.setState((prevState) => ({
                      items: prevState.items.map((item) =>
                        item.id_produto === id ? { ...item, contract: "" } : item
                      ),
                      TrashContract: {},
                    }));
                    toast.success("Contrato desvinculado!");
                  }
                });
              }}
            >
              Remover
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    );
  }
}

export default CadastroMaquina;